import Checkbox from './Checkbox/';
import CheckboxGroup from './CheckboxGroup/';
import DatePicker from './DatePicker/';
import FormGroup from './FormGroup/';
import RadioButton from './RadioButton/';
import StarRate from './StarRate/';
import Select from './Select/';
import SelectCreatable from './SelectCreatable/';
import Text from './Text/';
import Textarea from './Textarea/';
import Wysiwyg from './Wysiwyg/';

module.exports = {
  Checkbox,
  CheckboxGroup,
  DatePicker,
  FormGroup,
  RadioButton,
  StarRate,
  Select,
  SelectCreatable,
  Text,
  Textarea,
  Wysiwyg,
};



// WEBPACK FOOTER //
// ./components/FormElements/index.js